export default __webpack_public_path__ + "static/media/blank-loading.876ca8f9.png";